import { l as _inherits, h as _createClass, d as _objectSpread2, i as _classCallCheck, m as _callSuper } from './_rollupPluginBabelHelpers-e71b1aad.js';
import PropTypes from 'prop-types';
import React__default from 'react';

var PopupV2 = /*#__PURE__*/function (_React$Component) {
  function PopupV2(props) {
    var _this;
    _classCallCheck(this, PopupV2);
    _this = _callSuper(this, PopupV2, [props]);
    _this.triggerRef = React__default.createRef();
    _this.contentRef = React__default.createRef();
    _this.childrenRef = React__default.createRef();
    _this.state = {
      contentHeight: null,
      showScroll: false,
      showContent: false
    };
    _this.isHeightUpdated = false;
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.setContentHeight = _this.setContentHeight.bind(_this);
    _this.getContentClass = _this.getContentClass.bind(_this);
    _this.updateHeight = _this.updateHeight.bind(_this);
    return _this;
  }
  _inherits(PopupV2, _React$Component);
  return _createClass(PopupV2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClick);
      this.updateHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClick);
    }
  }, {
    key: "setContentHeight",
    value: function setContentHeight() {
      var scrollOnScreenLowerLimit = this.props.scrollOnScreenLowerLimit;
      if (scrollOnScreenLowerLimit && this.childrenRef && this.childrenRef.current) {
        var childrenClientRect = this.childrenRef.current.getBoundingClientRect();
        var totalHeightFromTop = Math.trunc(childrenClientRect.top + childrenClientRect.height);
        var windowHeight = Math.trunc(window.innerHeight);
        var diffBetweenChildrenAndWindow = windowHeight - totalHeightFromTop;
        var margin = 12;
        var extraMargin = margin + 15;
        if (diffBetweenChildrenAndWindow - extraMargin < 0) {
          this.setState({
            contentHeight: "".concat(windowHeight - childrenClientRect.top - margin, "px"),
            showScroll: true
          });
        } else {
          this.setState({
            contentHeight: "".concat(childrenClientRect.height + margin, "px"),
            showScroll: false
          });
        }
      }
    }
  }, {
    key: "getContentClass",
    value: function getContentClass() {
      var _this$props = this.props,
        className = _this$props.className,
        position = _this$props.position,
        size = _this$props.size,
        withoutArrow = _this$props.withoutArrow;
      var showScroll = this.state.showScroll;
      var scrollClassName = showScroll ? 'popup-scroll' : '';
      var arrowClassName = withoutArrow ? 'without-arrow' : '';
      var sizeClassName;
      switch (size) {
        case 'xsmall':
          sizeClassName = 'popup-xsmall';
          break;
        case 'small':
          sizeClassName = 'popup-small';
          break;
        case 'large':
          sizeClassName = 'popup-large';
          break;
        default:
          sizeClassName = '';
          break;
      }
      var positionClassName;
      switch (position) {
        case 'bottom':
          positionClassName = 'popup-bottom';
          break;
        case 'top':
          positionClassName = 'popup-top';
          break;
        case 'right':
          positionClassName = 'popup-right';
          break;
        case 'left':
          positionClassName = 'popup-left';
          break;
        default:
          positionClassName = 'popup-top';
          break;
      }
      return "popup-content ".concat(className, " ").concat(scrollClassName, " ").concat(arrowClassName, " ").concat(positionClassName, " ").concat(sizeClassName);
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this$triggerRef, _this$contentRef;
      var _this$props2 = this.props,
        isOpen = _this$props2.isOpen,
        onOpen = _this$props2.onOpen,
        onClose = _this$props2.onClose;
      var showContent = this.state.showContent;
      var triggerElement = (_this$triggerRef = this.triggerRef) === null || _this$triggerRef === void 0 ? void 0 : _this$triggerRef.current;
      var contentElement = (_this$contentRef = this.contentRef) === null || _this$contentRef === void 0 ? void 0 : _this$contentRef.current;
      var clickedElement = e.target;
      if ((isOpen || showContent) && ((triggerElement === null || triggerElement === void 0 ? void 0 : triggerElement.contains(clickedElement)) || contentElement && !contentElement.contains(clickedElement))) {
        if (isOpen === null) {
          this.setState({
            showContent: false
          });
        }
        onClose();
      } else if ((!isOpen || !showContent) && triggerElement && triggerElement.contains(clickedElement)) {
        if (isOpen === null) {
          this.setState({
            showContent: true
          });
        }
        onOpen();
      }
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      var showOnHover = this.props.showOnHover;
      var showContent = this.state.showContent;
      if (!showContent && showOnHover) {
        this.setState({
          showContent: true
        });
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      var showOnHover = this.props.showOnHover;
      var showContent = this.state.showContent;
      if (showContent && showOnHover) {
        this.setState({
          showContent: false
        });
      }
    }
  }, {
    key: "updateHeight",
    value: function updateHeight() {
      if (this.isHeightUpdated) {
        this.isHeightUpdated = false;
      } else {
        this.setContentHeight();
        this.isHeightUpdated = true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        trigger = _this$props3.trigger,
        triggerRef = _this$props3.triggerRef,
        isOpen = _this$props3.isOpen,
        style = _this$props3.style,
        children = _this$props3.children,
        header = _this$props3.header,
        withoutArrow = _this$props3.withoutArrow,
        dataTestId = _this$props3.dataTestId;
      var _this$state = this.state,
        contentHeight = _this$state.contentHeight,
        showContent = _this$state.showContent;
      var dynamicHeight = contentHeight ? {
        height: contentHeight
      } : {};
      return /*#__PURE__*/React__default.createElement("div", {
        className: "bf-popup-v2"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "popup-base",
        ref: triggerRef,
        "data-test-id": dataTestId
      }, /*#__PURE__*/React__default.createElement("span", {
        ref: this.triggerRef,
        className: "popup-trigger",
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, trigger), isOpen || showContent ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        ref: this.contentRef,
        style: _objectSpread2(_objectSpread2({}, style), dynamicHeight),
        className: this.getContentClass()
      }, header ? /*#__PURE__*/React__default.createElement("div", {
        className: "popup-header"
      }, header) : null, /*#__PURE__*/React__default.createElement("div", {
        className: "popup-children",
        ref: this.childrenRef
      }, children)), !withoutArrow && /*#__PURE__*/React__default.createElement("span", {
        className: "popup-arrow"
      })) : null));
    }
  }]);
}(React__default.Component);
PopupV2.defaultProps = {
  triggerRef: function triggerRef() {},
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  style: {},
  className: '',
  size: '',
  position: 'bottom',
  header: null,
  scrollOnScreenLowerLimit: false,
  showOnHover: false,
  withoutArrow: false,
  isOpen: null,
  dataTestId: null
};
PopupV2.propTypes = {
  trigger: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  triggerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  style: PropTypes.shape({}),
  className: PropTypes.string,
  size: PropTypes.string,
  position: PropTypes.string,
  header: PropTypes.node,
  scrollOnScreenLowerLimit: PropTypes.bool,
  showOnHover: PropTypes.bool,
  withoutArrow: PropTypes.bool,
  isOpen: PropTypes.bool,
  dataTestId: PropTypes.string
};

export { PopupV2 as P };
//# sourceMappingURL=PopupV2-57d71c2c.js.map
